import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoderHome from "./CoderHome";
import ToDoList from "./ToDoList";
import AuthContext from "../Auth/Middleware/AuthContext";

const Index = () => {
  const [query, setQuery] = useState();
  const [filterForToDOList, setFilterForToDoList] = useState({});
  const [attendanceProp] = useState(false);
  const auth = useContext(AuthContext)

  const navigate = useNavigate();

  const tokenReplaced = localStorage.getItem("tokenReplaced");

  if (!tokenReplaced) {
    navigate("/redirect");
  }

  const isAttending =
    localStorage.getItem("attending") === "true" ? true : false;

  return (
    <>
      <CoderHome
        attendanceProp={attendanceProp}
        show={!isAttending}
        showtable={isAttending}
        query={query}
      />
      <ToDoList
        key={auth.globalLocationChangeNumber}
        showtable={isAttending}
        onQuery={setQuery}
        setFilterForToDoList={setFilterForToDoList}
        filterForToDOList={filterForToDOList}
      />
    </>
  );
};

export default Index;
